export const kanjiDictionary = {
  kanji: {
    kan_group3: {
      characters: {
        '一': { kun: ['ひと'], on: ['イチ', 'イツ'], meanings: ['one', 'single'] },
        '二': { kun: ['ふた'], on: ['ニ'], meanings: ['two'] },
        '三': { kun: ['み'], on: ['サン'], meanings: ['three'] },
        '四': { kun: ['よ', 'よん'], on: ['シ'], meanings: ['four'] },
        '五': { kun: ['いつ'], on: ['ゴ'], meanings: ['five'] },
        '六': { kun: ['む'], on: ['ロク'], meanings: ['six'] },
        '七': { kun: ['なな'], on: ['シチ'], meanings: ['seven'] },
        '八': { kun: ['や'], on: ['ハチ'], meanings: ['eight'] },
        '九': { kun: ['ここの'], on: ['キュウ', 'ク'], meanings: ['nine'] },
        '十': { kun: ['とお'], on: ['ジュウ'], meanings: ['ten'] },
        '百': { kun: [], on: ['ヒャク'], meanings: ['hundred'] },
        '千': { kun: [], on: ['セン'], meanings: ['thousand'] },
        '万': { kun: [], on: ['マン'], meanings: ['ten thousand', 'myriad'] },
        '円': { kun: [], on: ['エン'], meanings: ['yen', 'circle', 'round'] },
        '時': { kun: ['とき'], on: ['ジ'], meanings: ['time', 'hour'] }
      }
    },

    kan_group4: {
      characters: {
        '日': { kun: ['ひ'], on: ['ニチ', 'ジツ'], meanings: ['day', 'sun'] },
        '本': { kun: ['もと'], on: ['ホン'], meanings: ['book', 'origin', 'main'] },
        '人': { kun: ['ひと'], on: ['ジン', 'ニン'], meanings: ['person', 'people'] },
        '月': { kun: ['つき'], on: ['ゲツ', 'ガツ'], meanings: ['moon', 'month'] },
        '火': { kun: ['ひ'], on: ['カ'], meanings: ['fire'] },
        '水': { kun: ['みず'], on: ['スイ'], meanings: ['water'] },
        '木': { kun: ['き'], on: ['モク', 'ボク'], meanings: ['tree', 'wood'] },
        '金': { kun: ['かね'], on: ['キン'], meanings: ['gold', 'money', 'metal'] },
        '土': { kun: ['つち'], on: ['ド'], meanings: ['earth', 'soil'] },
        '曜': { kun: [], on: ['ヨウ'], meanings: ['weekday', 'shine'] },
        '上': { kun: ['うえ', 'あ'], on: ['ジョウ'], meanings: ['up', 'above', 'on/top'] },
        '下': { kun: ['した', 'さ'], on: ['カ', 'ゲ'], meanings: ['down', 'below', 'under'] },
        '中': { kun: ['なか'], on: ['チュウ'], meanings: ['inside', 'middle', 'center'] },
        '半': { kun: [], on: ['ハン'], meanings: ['half'] }
      }
    },

    kan_group5: {
      characters: {
        '山': { kun: ['やま'], on: ['サン'], meanings: ['mountain'] },
        '川': { kun: ['かわ'], on: ['セン'], meanings: ['river'] },
        '元': { kun: ['もと'], on: ['ゲン', 'ガン'], meanings: ['origin', 'source', 'former'] },
        '気': { kun: [], on: ['キ', 'ケ'], meanings: ['spirit', 'mood', 'air/energy'] },
        '天': { kun: ['あま'], on: ['テン'], meanings: ['heaven', 'sky'] },
        '私': { kun: ['わたし'], on: ['シ'], meanings: ['I', 'private'] },
        '今': { kun: ['いま'], on: ['コン'], meanings: ['now'] },
        '田': { kun: ['た'], on: ['デン'], meanings: ['rice field'] },
        '女': { kun: ['おんな'], on: ['ジョ'], meanings: ['woman', 'female'] },
        '男': { kun: ['おとこ'], on: ['ダン', 'ナン'], meanings: ['man', 'male'] },
        '見': { kun: ['み'], on: ['ケン'], meanings: ['see', 'look', 'watch'] },
        '行': { kun: ['い', 'ゆ'], on: ['コウ', 'ギョウ'], meanings: ['go', 'act', 'conduct'] },
        '食': { kun: ['た'], on: ['ショク'], meanings: ['eat', 'food'] },
        '飲': { kun: ['の'], on: ['イン'], meanings: ['drink'] }
      }
    },

    kan_group6: {
      characters: {
        '東': { kun: ['ひがし'], on: ['トウ'], meanings: ['east'] },
        '西': { kun: ['にし'], on: ['セイ'], meanings: ['west'] },
        '南': { kun: ['みなみ'], on: ['ナン'], meanings: ['south'] },
        '北': { kun: ['きた'], on: ['ホク'], meanings: ['north'] },
        '口': { kun: ['くち'], on: ['コウ'], meanings: ['mouth', 'opening', 'entrance'] },
        '出': { kun: ['で'], on: ['シュツ'], meanings: ['exit', 'go out', 'put out'] },
        '右': { kun: ['みぎ'], on: ['ウ'], meanings: ['right (direction)'] },
        '左': { kun: ['ひだり'], on: ['サ'], meanings: ['left (direction)'] },
        '分': { kun: ['わ'], on: ['ブン', 'フン'], meanings: ['part', 'minute', 'understand'] },
        '先': { kun: ['さき'], on: ['セン'], meanings: ['before', 'ahead', 'previous'] },
        '生': { kun: ['い', 'う', 'なま'], on: ['セイ'], meanings: ['life', 'birth', 'raw'] },
        '大': { kun: ['おお'], on: ['ダイ', 'タイ'], meanings: ['big', 'large'] },
        '学': { kun: ['まな'], on: ['ガク'], meanings: ['study', 'learning'] },
        '外': { kun: ['そと'], on: ['ガイ'], meanings: ['outside', 'other', 'foreign'] },
        '国': { kun: ['くに'], on: ['コク'], meanings: ['country', 'nation'] }
      }
    },

    kan_group7: {
      characters: {
        '京': { kun: ['みやこ'], on: ['キョウ'], meanings: ['capital', 'Kyoto'] },
        '子': { kun: ['こ'], on: ['シ'], meanings: ['child', 'kid'] },
        '小': { kun: ['ちい'], on: ['ショウ'], meanings: ['small', 'little'] },
        '会': { kun: ['あ'], on: ['カイ'], meanings: ['meet', 'meeting', 'association'] },
        '社': { kun: ['やしろ'], on: ['シャ'], meanings: ['company', 'shrine'] },
        '父': { kun: ['ちち'], on: ['フ'], meanings: ['father'] },
        '母': { kun: ['はは'], on: ['ボ'], meanings: ['mother'] },
        '高': { kun: ['たか'], on: ['コウ'], meanings: ['tall', 'high', 'expensive'] },
        '校': { kun: [], on: ['コウ'], meanings: ['school', 'proof/correct'] },
        '毎': { kun: [], on: ['マイ'], meanings: ['every', 'each'] },
        '語': { kun: ['かた'], on: ['ゴ'], meanings: ['language', 'word', 'tell/speak'] },
        '文': { kun: ['ふみ'], on: ['ブン'], meanings: ['sentence', 'writing', 'literature'] },
        '帰': { kun: ['かえ'], on: ['キ'], meanings: ['return', 'go home'] },
        '入': { kun: ['はい', 'い'], on: ['ニュウ'], meanings: ['enter', 'put in'] }
      }
    },

    kan_group8: {
      characters: {
        '員': { kun: [], on: ['イン'], meanings: ['member', 'staff'] },
        '新': { kun: ['あたら'], on: ['シン'], meanings: ['new'] },
        '聞': { kun: ['き'], on: ['ブン', 'モン'], meanings: ['hear', 'listen', 'ask'] },
        '作': { kun: ['つく'], on: ['サク', 'サ'], meanings: ['make', 'create', 'produce'] },
        '仕': { kun: ['つか'], on: ['シ'], meanings: ['serve', 'do (work)'] },
        '事': { kun: ['こと'], on: ['ジ'], meanings: ['thing', 'matter', 'event'] },
        '電': { kun: [], on: ['デン'], meanings: ['electricity'] },
        '車': { kun: ['くるま'], on: ['シャ'], meanings: ['car', 'vehicle'] },
        '休': { kun: ['やす'], on: ['キュウ'], meanings: ['rest', 'break', 'holiday'] },
        '言': { kun: ['い'], on: ['ゲン', 'ゴン'], meanings: ['say', 'words', 'speech'] },
        '読': { kun: ['よ'], on: ['ドク'], meanings: ['read'] },
        '思': { kun: ['おも'], on: ['シ'], meanings: ['think', 'feel'] },
        '次': { kun: ['つぎ'], on: ['ジ'], meanings: ['next', 'following'] },
        '何': { kun: ['なに'], on: ['ナン'], meanings: ['what', 'how many'] }
      }
    },

    kan_group9: {
      characters: {
        '午': { kun: [], on: ['ゴ'], meanings: ['noon', 'midday'] },
        '後': { kun: ['のち', 'うしろ', 'あと'], on: ['ゴ'], meanings: ['after', 'later', 'behind'] },
        '前': { kun: ['まえ'], on: ['ゼン'], meanings: ['before', 'front'] },
        '名': { kun: ['な'], on: ['メイ', 'ミョウ'], meanings: ['name', 'fame'] },
        '白': { kun: ['しろ'], on: ['ハク'], meanings: ['white'] },
        '雨': { kun: ['あめ'], on: ['ウ'], meanings: ['rain'] },
        '書': { kun: ['か'], on: ['ショ'], meanings: ['write', 'book'] },
        '友': { kun: ['とも'], on: ['ユウ'], meanings: ['friend'] },
        '間': { kun: ['あいだ', 'ま'], on: ['カン', 'ゲン'], meanings: ['interval', 'between', 'space/room'] },
        '家': { kun: ['いえ', 'や'], on: ['カ', 'ケ'], meanings: ['house', 'home', 'family'] },
        '話': { kun: ['はな'], on: ['ワ'], meanings: ['talk', 'story'] },
        '少': { kun: ['すこ', 'すく'], on: ['ショウ'], meanings: ['few', 'little'] },
        '古': { kun: ['ふる'], on: ['コ'], meanings: ['old'] },
        '知': { kun: ['し'], on: ['チ'], meanings: ['know'] },
        '来': { kun: ['く', 'き', 'こ'], on: ['ライ'], meanings: ['come', 'next (year/etc.)'] }
      }
    },

    kan_group10: {
      characters: {
        '住': { kun: ['す'], on: ['ジュウ'], meanings: ['live', 'reside'] },
        '正': { kun: ['ただ'], on: ['ショウ', 'セイ'], meanings: ['correct', 'right', 'exact'] },
        '年': { kun: ['とし'], on: ['ネン'], meanings: ['year'] },
        '売': { kun: ['う'], on: ['バイ'], meanings: ['sell'] },
        '買': { kun: ['か'], on: ['バイ'], meanings: ['buy'] },
        '町': { kun: ['まち'], on: ['チョウ'], meanings: ['town', 'block'] },
        '長': { kun: ['なが'], on: ['チョウ'], meanings: ['long', 'leader/chief'] },
        '道': { kun: ['みち'], on: ['ドウ'], meanings: ['road', 'way', 'path'] },
        '雪': { kun: ['ゆき'], on: ['セツ'], meanings: ['snow'] },
        '立': { kun: ['た'], on: ['リツ'], meanings: ['stand', 'set up/establish'] },
        '自': { kun: ['みずか'], on: ['ジ', 'シ'], meanings: ['self'] },
        '夜': { kun: ['よる', 'よ'], on: ['ヤ'], meanings: ['night', 'evening'] },
        '朝': { kun: ['あさ'], on: ['チョウ'], meanings: ['morning'] },
        '持': { kun: ['も'], on: ['ジ'], meanings: ['hold', 'have/possess', 'carry'] }
      }
    },

    kan_group11: {
      characters: {
        '手': { kun: ['て'], on: ['シュ'], meanings: ['hand'] },
        '紙': { kun: ['かみ', 'がみ'], on: ['シ'], meanings: ['paper'] },
        '好': { kun: ['す', 'この'], on: ['コウ'], meanings: ['like', 'fond', 'favorable'] },
        '近': { kun: ['ちか'], on: ['キン'], meanings: ['near', 'close'] },
        '明': { kun: ['あか', 'あ'], on: ['メイ'], meanings: ['bright', 'clear', 'next (day)'] },
        '病': { kun: ['やまい'], on: ['ビョウ'], meanings: ['illness', 'sick'] },
        '院': { kun: [], on: ['イン'], meanings: ['institution', 'hospital'] },
        '映': { kun: ['うつ'], on: ['エイ'], meanings: ['reflect', 'project (film)', 'be映る'] },
        '画': { kun: ['え'], on: ['ガ', 'カ'], meanings: ['picture', 'drawing', 'stroke'] },
        '歌': { kun: ['うた'], on: ['カ'], meanings: ['song', 'sing'] },
        '市': { kun: ['いち'], on: ['シ'], meanings: ['city', 'market'] },
        '所': { kun: ['ところ', 'どころ'], on: ['ジョ', 'ショ'], meanings: ['place'] },
        '勉': { kun: ['つと'], on: ['ベン'], meanings: ['exert', 'diligence'] },
        '強': { kun: ['つよ'], on: ['キョウ', 'ゴウ'], meanings: ['strong', 'force', 'compel'] },
        '有': { kun: ['あ'], on: ['ユウ'], meanings: ['have', 'exist'] },
        '旅': { kun: ['たび'], on: ['リョ'], meanings: ['travel', 'trip'] }
      }
    },

    kan_group12: {
      characters: {
        '昔': { kun: ['むかし'], on: [], meanings: ['long ago', 'the past'] },
        '々': { kun: [], on: [], meanings: ['iteration mark', 'repeat previous kanji'] }, // Iteration mark
        '神': { kun: ['かみ', 'がみ'], on: ['シン', 'ジン'], meanings: ['god', 'spirit', 'deity'] },
        '早': { kun: ['はや'], on: ['ソウ'], meanings: ['early', 'fast'] },
        '起': { kun: ['お'], on: ['キ'], meanings: ['wake up', 'rise', 'occur'] },
        '牛': { kun: ['うし'], on: ['ギュウ'], meanings: ['cow', 'ox'] },
        '使': { kun: ['つか'], on: ['シ'], meanings: ['use', 'messenger'] },
        '働': { kun: ['はたら'], on: ['ドウ'], meanings: ['work', 'labor'] },
        '連': { kun: ['つ'], on: ['レン'], meanings: ['link', 'take along', 'group'] },
        '別': { kun: ['わか'], on: ['ベツ'], meanings: ['separate', 'different'] },
        '度': { kun: ['たび'], on: ['ド'], meanings: ['degree', 'time (occurrence)', 'counter for times'] },
        '赤': { kun: ['あか'], on: ['セキ'], meanings: ['red'] },
        '青': { kun: ['あお'], on: ['セイ'], meanings: ['blue', 'green'] },
        '色': { kun: ['いろ'], on: ['シキ', 'ショク'], meanings: ['color'] }
      }
    },

    // Genki II (Lessons 13-23)
    kan_group13: {
      characters: {
        '物': { kun: ['もの'], on: ['ブツ', 'モツ'], meanings: ['thing', 'object'] },
        '鳥': { kun: ['とり'], on: ['チョウ'], meanings: ['bird'] },
        '料': { kun: [], on: ['リョウ'], meanings: ['fee', 'materials', 'charge'] },
        '理': { kun: [], on: ['リ'], meanings: ['reason', 'logic', 'manage'] },
        '特': { kun: [], on: ['トク', 'トッ'], meanings: ['special'] },
        '安': { kun: ['やす'], on: ['アン'], meanings: ['cheap', 'safe', 'peaceful'] },
        '飯': { kun: ['めし'], on: ['ハン'], meanings: ['cooked rice', 'meal'] },
        '肉': { kun: [], on: ['ニク'], meanings: ['meat', 'flesh'] },
        '悪': { kun: ['わる'], on: ['アク'], meanings: ['bad', 'evil', 'wrong'] },
        '体': { kun: ['からだ'], on: ['タイ'], meanings: ['body'] },
        '同': { kun: ['おな'], on: ['ドウ'], meanings: ['same', 'together'] },
        '着': { kun: ['き', 'つ', 'ぎ'], on: ['チャク'], meanings: ['wear', 'arrive', 'attach'] },
        '空': { kun: ['そら', 'あ', 'から'], on: ['クウ'], meanings: ['sky', 'empty', 'vacant'] },
        '港': { kun: ['みなと'], on: ['コウ'], meanings: ['harbor', 'port'] },
        '昼': { kun: ['ひる'], on: ['チュウ'], meanings: ['daytime', 'noon'] },
        '海': { kun: ['うみ'], on: ['カイ'], meanings: ['sea', 'ocean'] }
      }
    },

    kan_group14: {
      characters: {
        '彼': { kun: ['かれ', 'かの'], on: [], meanings: ['he', 'that (one)'] },
        '代': { kun: ['か'], on: ['ダイ'], meanings: ['replace', 'generation', 'era'] },
        '留': { kun: ['と'], on: ['リュウ', 'ル'], meanings: ['stay', 'remain'] },
        '族': { kun: [], on: ['ゾク'], meanings: ['tribe', 'family/group'] },
        '親': { kun: ['おや', 'した'], on: ['シン'], meanings: ['parent', 'close/intimate'] },
        '切': { kun: ['き', 'きっ'], on: ['セツ'], meanings: ['cut', 'be sharp', 'turn off'] },
        '英': { kun: [], on: ['エイ'], meanings: ['England', 'English', 'excellent'] },
        '店': { kun: ['みせ'], on: ['テン'], meanings: ['shop', 'store'] },
        '去': { kun: ['さ'], on: ['キョ', 'コ'], meanings: ['leave', 'past'] },
        '急': { kun: ['いそ'], on: ['キュウ'], meanings: ['hurry', 'sudden'] },
        '乗': { kun: ['の'], on: ['ジョウ'], meanings: ['ride', 'get on'] },
        '当': { kun: ['あ'], on: ['トウ'], meanings: ['hit', 'be right', 'this/that (relevant)'] },
        '音': { kun: ['おと', 'ね'], on: ['オン'], meanings: ['sound'] },
        '楽': { kun: ['たの'], on: ['ガク', 'ラク'], meanings: ['music', 'comfort', 'enjoy'] },
        '医': { kun: [], on: ['イ'], meanings: ['medicine', 'doctor'] },
        '者': { kun: ['もの'], on: ['シャ'], meanings: ['person', 'someone', '-er'] }
      }
    },

    kan_group15: {
      characters: {
        '死': { kun: ['し'], on: ['シ'], meanings: ['death', 'die'] },
        '意': { kun: [], on: ['イ'], meanings: ['meaning', 'intention', 'mind'] },
        '味': { kun: ['あじ'], on: ['ミ'], meanings: ['taste', 'flavor', 'meaning'] },
        '注': { kun: ['そそ'], on: ['チュウ'], meanings: ['pour', 'note', 'attention'] },
        '夏': { kun: ['なつ'], on: ['カ'], meanings: ['summer'] },
        '魚': { kun: ['さかな', 'うお'], on: ['ギョ'], meanings: ['fish'] },
        '寺': { kun: ['てら', 'でら'], on: ['ジ'], meanings: ['temple'] },
        '広': { kun: ['ひろ'], on: ['コウ'], meanings: ['wide', 'broad', 'spacious'] },
        '足': { kun: ['あし', 'た'], on: ['ソク'], meanings: ['foot', 'leg', 'sufficient'] },
        '転': { kun: ['ころ'], on: ['テン'], meanings: ['roll', 'turn', 'transfer'] },
        '借': { kun: ['か'], on: ['シャク', 'シャッ'], meanings: ['borrow', 'rent'] },
        '走': { kun: ['はし'], on: ['ソウ'], meanings: ['run'] },
        '場': { kun: ['ば'], on: ['ジョウ'], meanings: ['place', 'scene', 'situation'] },
        '建': { kun: ['た'], on: ['ケン'], meanings: ['build', 'construct'] },
        '地': { kun: [], on: ['チ', 'ジ'], meanings: ['ground', 'earth', 'land'] },
        '通': { kun: ['とお', 'かよ'], on: ['ツウ'], meanings: ['pass through', 'commute', 'traffic'] }
      }
    },

    kan_group16: {
      characters: {
        '供': { kun: ['ども', 'そな'], on: ['キョウ'], meanings: ['offer', 'accompany', 'attendant'] },
        '世': { kun: ['よ'], on: ['セイ', 'セ'], meanings: ['world', 'generation', 'society'] },
        '界': { kun: [], on: ['カイ'], meanings: ['world', 'boundary'] },
        '全': { kun: ['まった'], on: ['ゼン'], meanings: ['all', 'whole'] },
        '部': { kun: [], on: ['ブ'], meanings: ['part', 'section', 'department'] },
        '始': { kun: ['はじ'], on: ['シ'], meanings: ['begin', 'start'] },
        '週': { kun: [], on: ['シュウ'], meanings: ['week'] },
        '考': { kun: ['かんが'], on: ['コウ'], meanings: ['think', 'consider'] },
        '開': { kun: ['あ', 'ひら'], on: ['カイ'], meanings: ['open', 'begin (event)'] },
        '屋': { kun: ['や'], on: ['オク'], meanings: ['roof', 'shop', 'seller'] },
        '方': { kun: ['かた', 'がた'], on: ['ホウ'], meanings: ['direction', 'person (polite)', 'method'] },
        '運': { kun: ['はこ'], on: ['ウン'], meanings: ['carry', 'luck', 'transport'] },
        '動': { kun: ['うご'], on: ['ドウ'], meanings: ['move'] },
        '教': { kun: ['おし'], on: ['キョウ'], meanings: ['teach', 'religion/doctrine'] },
        '室': { kun: [], on: ['シツ'], meanings: ['room', 'chamber'] },
        '以': { kun: [], on: ['イ'], meanings: ['by means of', 'because', 'from…on'] }
      }
    },

    kan_group17: {
      characters: {
        '野': { kun: ['の'], on: ['ヤ'], meanings: ['field', 'plain', 'wild'] },
        '習': { kun: ['なら'], on: ['シュウ'], meanings: ['learn', 'practice'] },
        '主': { kun: ['おも', 'ぬし'], on: ['シュ'], meanings: ['main', 'lord', 'owner'] },
        '歳': { kun: [], on: ['サイ', 'セイ'], meanings: ['years old', 'age'] },
        '集': { kun: ['あつ'], on: ['シュウ'], meanings: ['gather', 'collect'] },
        '発': { kun: [], on: ['ハツ', 'ハッ', 'パツ'], meanings: ['depart', 'emit', 'start/launch'] },
        '表': { kun: ['あらわ', 'おもて'], on: ['ピョウ', 'ヒョウ'], meanings: ['surface', 'express', 'table/chart'] },
        '品': { kun: ['しな', 'じな'], on: ['ヒン'], meanings: ['goods', 'article', 'quality'] },
        '写': { kun: ['うつ'], on: ['シャ'], meanings: ['copy', 'photograph'] },
        '真': { kun: ['ま'], on: ['シン'], meanings: ['true', 'real'] },
        '字': { kun: [], on: ['ジ'], meanings: ['character', 'letter'] },
        '活': { kun: [], on: ['カツ'], meanings: ['active', 'life (as in lifestyle)', 'revive'] },
        '結': { kun: ['むす'], on: ['ケツ', 'ケッ'], meanings: ['tie', 'conclude', 'result'] },
        '婚': { kun: [], on: ['コン'], meanings: ['marriage'] },
        '歩': { kun: ['ある'], on: ['ホ', 'ポ'], meanings: ['walk', 'step'] }
      }
    },

    kan_group18: {
      characters: {
        '目': { kun: ['め'], on: ['モク'], meanings: ['eye', 'item/point'] },
        '的': { kun: [], on: ['テキ'], meanings: ['target', '-like (suffix)'] },
        '洋': { kun: [], on: ['ヨウ'], meanings: ['ocean', 'Western'] },
        '服': { kun: [], on: ['フク'], meanings: ['clothes', 'obey'] },
        '堂': { kun: [], on: ['ドウ'], meanings: ['hall', 'temple building'] },
        '力': { kun: ['ちから'], on: ['リョク', 'リキ'], meanings: ['power', 'strength'] },
        '授': { kun: ['さず'], on: ['ジュ'], meanings: ['grant', 'teach', 'confer'] },
        '業': { kun: [], on: ['ギョウ'], meanings: ['work', 'business', 'karma'] },
        '試': { kun: ['こころ'], on: ['シ'], meanings: ['test', 'try'] },
        '験': { kun: [], on: ['ケン'], meanings: ['test', 'effect', 'verification'] },
        '貸': { kun: ['か'], on: ['タイ'], meanings: ['lend', 'rent out'] },
        '図': { kun: ['はか'], on: ['ト', 'ズ'], meanings: ['diagram', 'map', 'plan'] },
        '館': { kun: [], on: ['カン'], meanings: ['building', 'hall', 'facility'] },
        '終': { kun: ['お'], on: ['シュウ'], meanings: ['end', 'finish'] },
        '宿': { kun: ['やど'], on: ['シュク'], meanings: ['lodging', 'inn', 'stay over'] },
        '題': { kun: [], on: ['ダイ'], meanings: ['topic', 'title', 'problem'] }
      }
    },

    kan_group19: {
      characters: {
        '春': { kun: ['はる'], on: ['シュン'], meanings: ['spring'] },
        '秋': { kun: ['あき'], on: ['シュウ'], meanings: ['autumn', 'fall'] },
        '冬': { kun: ['ふゆ'], on: ['トウ'], meanings: ['winter'] },
        '花': { kun: ['はな', 'ばな'], on: ['カ'], meanings: ['flower'] },
        '様': { kun: ['さま'], on: ['ヨウ'], meanings: ['appearance', 'manner', 'Mr./Ms. (honorific)'] },
        '不': { kun: [], on: ['フ', 'ブ'], meanings: ['not', 'non-', 'negative'] },
        '姉': { kun: ['あね', 'ねい'], on: ['シ'], meanings: ['older sister'] },
        '兄': { kun: ['あに', 'ねい'], on: ['キョウ'], meanings: ['older brother'] },
        '漢': { kun: [], on: ['カン'], meanings: ['Chinese (Han)', 'manly'] },
        '卒': { kun: [], on: ['ソツ'], meanings: ['graduate', 'end'] },
        '工': { kun: [], on: ['コウ', 'ク'], meanings: ['craft', 'construction', 'industry'] },
        '研': { kun: ['と'], on: ['ケン'], meanings: ['sharpen', 'study/research'] },
        '究': { kun: ['きわ'], on: ['キュウ'], meanings: ['research', 'investigate', 'go to the end'] },
        '質': { kun: [], on: ['シツ', 'シチ'], meanings: ['quality', 'matter/substance', 'temperament'] },
        '問': { kun: ['と'], on: ['モン'], meanings: ['question', 'ask', 'problem'] },
        '多': { kun: ['おお'], on: ['タ'], meanings: ['many', 'much'] }
      }
    },

    kan_group20: {
      characters: {
        '皿': { kun: ['さら', 'ざら'], on: [], meanings: ['plate', 'dish'] },
        '声': { kun: ['こえ'], on: ['セイ'], meanings: ['voice', 'sound'] },
        '茶': { kun: [], on: ['チャ', 'サ'], meanings: ['tea'] },
        '止': { kun: ['と'], on: ['シ'], meanings: ['stop'] },
        '枚': { kun: [], on: ['マイ'], meanings: ['counter for flat objects'] },
        '両': { kun: [], on: ['リョウ'], meanings: ['both', 'two', 'counter for vehicles'] },
        '無': { kun: ['な'], on: ['ム', 'ブ'], meanings: ['nothing', 'none', 'without'] },
        '払': { kun: ['はら', 'ばら'], on: [], meanings: ['pay', 'sweep away'] },
        '心': { kun: ['こころ'], on: ['シン'], meanings: ['heart', 'mind'] },
        '笑': { kun: ['わら', 'え'], on: ['ショウ'], meanings: ['laugh', 'smile'] },
        '絶': { kun: ['た'], on: ['ゼツ', 'ゼッ'], meanings: ['cut off', 'die out', 'excellent (絶対 etc.)'] },
        '対': { kun: [], on: ['タイ', 'ツイ'], meanings: ['opposite', 'versus', 'pair'] },
        '痛': { kun: ['いた'], on: ['ツウ'], meanings: ['pain', 'hurt'] },
        '最': { kun: ['もっと'], on: ['サイ'], meanings: ['most', 'extreme'] },
        '続': { kun: ['つづ'], on: ['ゾク'], meanings: ['continue'] }
      }
    },

    kan_group21: {
      characters: {
        '信': { kun: [], on: ['シン'], meanings: ['trust', 'believe', 'faith'] },
        '経': { kun: [], on: ['ケイ'], meanings: ['pass through', 'manage', 'sutra'] },
        '台': { kun: [], on: ['ダイ', 'タイ'], meanings: ['stand', 'platform', 'machine counter'] },
        '風': { kun: ['かぜ'], on: ['フウ', 'フ'], meanings: ['wind', 'style', 'cold/flu'] },
        '犬': { kun: ['いぬ'], on: ['ケン'], meanings: ['dog'] },
        '重': { kun: ['おも', 'かさ'], on: ['ジュウ', 'チョウ'], meanings: ['heavy', 'important', 'pile up'] },
        '初': { kun: ['はじ', 'はつ'], on: ['ショ'], meanings: ['first', 'beginning'] },
        '若': { kun: ['わか'], on: [], meanings: ['young', 'if (classical/kanbun)'] },
        '送': { kun: ['おく'], on: ['ソウ'], meanings: ['send', 'see off'] },
        '幸': { kun: ['しあわ', 'さいわ'], on: ['コウ'], meanings: ['happiness', 'good fortune'] },
        '計': { kun: ['はか'], on: ['ケイ'], meanings: ['measure', 'plan', 'count'] },
        '遅': { kun: ['おく', 'おそ'], on: ['チ'], meanings: ['late', 'slow'] },
        '配': { kun: ['くば'], on: ['ハイ', 'パイ'], meanings: ['distribute', 'hand out', 'worry/consider'] },
        '弟': { kun: ['おとうと'], on: ['ダイ', 'テイ'], meanings: ['younger brother'] },
        '妹': { kun: ['いもうと'], on: ['マイ'], meanings: ['younger sister'] }
      }
    },

    kan_group22: {
      characters: {
        '記': { kun: [], on: ['キ'], meanings: ['record', 'write down', 'account'] },
        '銀': { kun: [], on: ['ギン'], meanings: ['silver'] },
        '回': { kun: ['まわ'], on: ['カイ'], meanings: ['times (counter)', 'turn around', 'rotate'] },
        '夕': { kun: ['ゆう'], on: ['セキ'], meanings: ['evening'] },
        '黒': { kun: ['くろ'], on: ['コク'], meanings: ['black'] },
        '用': { kun: ['もち'], on: ['ヨウ'], meanings: ['use', 'business', 'need'] },
        '末': { kun: ['すえ'], on: ['マツ'], meanings: ['end', 'tip', 'future'] },
        '待': { kun: ['ま'], on: ['タイ'], meanings: ['wait'] },
        '残': { kun: ['のこ'], on: ['ザン'], meanings: ['remain', 'left over'] },
        '駅': { kun: [], on: ['エキ'], meanings: ['station'] },
        '番': { kun: [], on: ['バン'], meanings: ['turn', 'number', 'guard/watch'] },
        '説': { kun: ['と'], on: ['セツ', 'ゼッ'], meanings: ['explain', 'theory', 'opinion'] },
        '案': { kun: [], on: ['アン'], meanings: ['plan', 'proposal', 'idea'] },
        '内': { kun: ['うち'], on: ['ナイ'], meanings: ['inside', 'within'] },
        '忘': { kun: ['わす'], on: ['ボウ'], meanings: ['forget'] },
        '守': { kun: ['まも'], on: ['シュ', 'ス'], meanings: ['protect', 'obey', 'guard'] }
      }
    },

    kan_group23: {
      characters: {
        '顔': { kun: ['かお'], on: ['ガン'], meanings: ['face'] },
        '悲': { kun: ['かな'], on: ['ヒ'], meanings: ['sad', 'grieve'] },
        '怒': { kun: ['おこ', 'いか'], on: ['ド'], meanings: ['anger', 'get angry'] },
        '違': { kun: ['ちが'], on: ['イ'], meanings: ['different', 'wrong', 'differ'] },
        '変': { kun: ['か'], on: ['ヘン'], meanings: ['change', 'strange'] },
        '比': { kun: ['くら'], on: ['ヒ'], meanings: ['compare', 'ratio'] },
        '情': { kun: ['なさ'], on: ['ジョウ'], meanings: ['feeling', 'emotion', 'sympathy'] },
        '感': { kun: [], on: ['カン'], meanings: ['feeling', 'sense', 'emotion'] },
        '調': { kun: ['しら'], on: ['チョウ'], meanings: ['investigate', 'tone', 'condition'] },
        '査': { kun: [], on: ['サ'], meanings: ['inspect', 'investigate'] },
        '果': { kun: ['は'], on: ['カ'], meanings: ['fruit', 'result', 'accomplish'] },
        '化': { kun: ['ば'], on: ['カ', 'ケ'], meanings: ['change', '-ize', 'transform'] },
        '横': { kun: ['よこ'], on: ['オウ'], meanings: ['side', 'horizontal'] },
        '相': { kun: ['あい'], on: ['ソウ', 'ショウ'], meanings: ['mutual', 'appearance', 'minister/phase'] },
        '答': { kun: ['こた'], on: ['トウ'], meanings: ['answer', 'response'] }
      }
    }
  }
};
